import { render } from "./index.vue?vue&type=template&id=010e6c25"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=010e6c25&lang=css"

import exportComponent from "E:\\sunjibo\\upstream_space\\code\\shenzhou\\medical-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__